// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsLinks_HistoricoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /payments/links/historico/{id}
 *
 * Returns a chronological timeline of payment link events.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type SubaccountsLinks_HistoricoResponseDados = unknown[];

export type SubaccountsLinks_HistoricoResponse = ApiResponse<SubaccountsLinks_HistoricoResponseDados>;

registerResponseContract('SubaccountsLinks_HistoricoResponse', {})
